import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "..";

import "./styles.css";

const Education = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );
  const studentProfile = useSelector(
    (state) => state?.students?.student?.common
  );

  const [state, setState] = useState({
    expectedGradYear: null,
    curriculum: null,
  });

  useEffect(() => {
    setState({
      expectedGradYear: questionnaire?.expectedGradYear ?? null,
      curriculum: questionnaire?.curriculum ?? null,
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div className="grid grid-cols-2 gap-x-7 gap-y-6">
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Current School"
            required
          />
          <Spacer height="0.3125em" />
          <inputFields.DefaultInput
            placeholder="Dubai School"
            value={`${studentProfile?.student?.school?.userId?.firstName} ${studentProfile?.student?.school?.userId?.lastName}`}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Current Grade"
            required
          />
          <Spacer height="0.3125em" />
          <inputFields.DefaultInput
            placeholder="grade"
            value={studentProfile?.student?.grade}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel text="Expected Graduation Year" />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.expectedGradYear}
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Curriculum"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.curriculum}
          />
        </div>
      </div>
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("High School Grades")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Education;
